export default [
  {
    path: "/contratos",
    component: () =>
      import(/* webpackChunkName: "contratos" */ "../views/Contratos.vue"),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        component: () =>
          import(
            /* webpackChunkName: "contratos-termos-adesao" */
            "../components/contratos/ContratoTermosAdesao.vue"
          ),
      },
      {
        path: "contrato-flex-familia",
        component: () =>
          import(
            /* webpackChunkName: "contratos-flex-familia" */
            "../components/contratos/ContratoFlexFamilia.vue"
          ),
      },
      {
        path: "contrato-flex-multi",
        component: () =>
          import(
            /* webpackChunkName: "contratos-flex-multi" */
            "../components/contratos/ContratoFlexMulti.vue"
          ),
      },
    ],
  },
];
